import React from 'react'
import { TableType } from '@components/Table/interface'

export function withTable(Component: React.FC<TableType>) {
  function WithTable({ ...props }: TableType) {
    return <Component {...props} />
  }
  return WithTable
}
